import { FrameTool } from '../../../core/tools/standard/FrameTool';
import { IToolManifest } from '../../../core/tools/interfaces/ITool';
import { Frame, IFrame, IFrameBounds } from '../../../core/frames/IFrame';
import { DiagramType } from '../../../core/tools/interfaces/ITool';
import i18n from '@/i18n/config';
import { bindGenogramToolName } from './utils/toolNameI18n';

export class GenogramFrameTool extends FrameTool {
  manifest: IToolManifest;
  
  private frameManager: any; // Will be set by the component
  
  constructor() {
    super();
    
    this.manifest = {
      ...this.getBaseManifest(),
      id: 'genogram-frame',
      name: i18n.t('genogram:tools.familyFrame', { defaultValue: 'Family Frame' }) as string,
      icon: '⬚',
      description: 'Create frames to group family members',
      supportedDiagramTypes: ['genogram'],
    } as IToolManifest;

    bindGenogramToolName(this.manifest, 'tools.familyFrame', 'Family Frame');
  }
  
  setFrameManager(frameManager: any): void {
    this.frameManager = frameManager;
  }
  
  getFrameTypes(): { value: DiagramType; label: string; icon?: string }[] {
    return [
      { value: 'genogram', label: 'Family Group', icon: '👨‍👩‍👧‍👦' },
      { value: 'generic', label: 'Generic Frame', icon: '⬚' }
    ];
  }
  
  createFrame(bounds: IFrameBounds, type: DiagramType): IFrame {
    const frameCount = this.frameManager?.getAllFrames?.()?.length || 0;
    
    const n = frameCount + 1;
    const frame = new Frame({
      id: `frame-${Date.now()}`,
      name:
        type === 'genogram'
          ? (i18n.t('genogram:tools.defaultFamilyGroupName', { n, defaultValue: `Family ${n}` }) as string)
          : (i18n.t('genogram:tools.defaultGenericFrameName', { n, defaultValue: `Frame ${n}` }) as string),
      type,
      bounds,
      // Frames should be outline only (no background fill)
      backgroundColor: undefined,
      borderColor: '#E5E7EB',
      borderWidth: 2,
      opacity: 1,
      metadata: {
        createdAt: new Date().toISOString(),
        familyName: type === 'genogram' ? '' : undefined
      }
    });
    // If creating inside another frame, set parentFrame
    try {
      if (this.frameManager) {
        const center = { x: bounds.x + bounds.width / 2, y: bounds.y + bounds.height / 2 };
        const parent = this.frameManager.getFrameAtPoint(center, true);
        if (parent) {
          frame.setParentFrame(parent.id);
        }
      }
    } catch (_) {}
    return frame;
  }
  
  addFrame(frame: IFrame): void {
    if (this.frameManager) {
      this.frameManager.addFrame(frame);
      // If parentFrame is set, link into parent
      if (frame.parentFrame) {
        const parent = this.frameManager.getFrame(frame.parentFrame);
        parent?.addChildFrame(frame.id);
      }
    }
  }
  
  removeFrame(frameId: string): void {
    if (this.frameManager) {
      this.frameManager.removeFrame(frameId);
    }
  }
  
  getFrame(frameId: string): IFrame | undefined {
    if (this.frameManager) {
      return this.frameManager.getFrame(frameId);
    }
    return undefined;
  }
}